import { Flex } from 'antd'
import Image from '@/components/image'
import { TextContent } from '../integration'
import imageRoadmap from '@/assets/img/solution/school-bus/roadmap.jpg'
import Styles from './style.module.scss'

const TITLE = 'Implementation Roadmap'
const data = [
  {
    title: 'Assessment & Route Planning',
    descriptions: ['Match bus models with fleet schedules'],
  },
  {
    title: 'Procurement Support',
    descriptions: ['Secure grants(ZESBI, ITC,HVIP,SGIP)'],
  },
  {
    title: 'Charging Infrastructure',
    descriptions: ['Scalable, compatible, future- proof stations'],
  },
]

export default function Roadmap() {
  return (
    <div className={Styles.roadmap}>
      <h2>{TITLE}</h2>
      <Flex align='center' className={Styles.content}>
        <TextContent data={data} />
        <Image src={imageRoadmap} alt='roadmap' rootClassName={Styles.image} />
      </Flex>
    </div>
  )
}
